<template>
    <v-dialog
        v-if="visible"
        v-model="visible"
        transition="dialog-top-transition"
        scrollable
        persistent
        max-width="800"
    >
        <v-card class="modal-maincard">

            <v-toolbar dark flat dense>
                <v-toolbar-title>{{$t(title)}}</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="wrapperFormModal">
                <v-card flat>
                    <v-card-text v-if="loading">
                        <v-col class="text-subtitle-1 text-center" cols="12">
                            {{ $t("Загрузка...") }}
                        </v-col>
                        <v-col cols="12">
                            <v-progress-linear color="#a94442" indeterminate rounded height="6" />
                        </v-col>
                    </v-card-text>
                    <v-card-text v-else>
                        <div class="form-box-title title-with-right-part">
                            <span>
                                {{ $t("Доступно") }}
                            </span>
                            <div class="twrp-content">
                                <v-text-field
                                    v-model="search"
                                    :placeholder="$t('Поиск')"
                                    hide-details
                                    dense
                                    clearable
                                    required
                                    @click:clear="search = null"
                                    class="twrp-search"
                                    append-icon="fas fa-search"
                                >
                                </v-text-field>
                                <div class="twrp-action" @click="refreshData">
                                    <v-icon role="button" small left>
                                        far fa-sync-alt
                                    </v-icon>
                                </div>
                            </div>
                        </div>
                        <v-virtual-scroll
                            v-if="visibleItems.length > 0"
                            :items="visibleItems"
                            item-height="40"
                            height="400"
                            bench="10"
                            class="virt-scrl-list-tree"
                        >
                            <template v-slot:default="{ item, index }">
                                <v-list-item
                                    :key="index"
                                    @click="onItemClick(item)"
                                    :style="{ marginLeft: item.isGroup ?  '0px' : '25px' }"
                                    v-ripple="{ class: `primary--text` }"
                                >

                                    <v-list-item-action 
                                        :class="[item.isGroup ? 'group-item-action' : '']"
                                    >
                                        <v-icon
                                            v-if="item.isGroup"
                                            small
                                        >
                                            {{ item.collapsed ? 'fas fa-caret-right' : 'fas fa-caret-down' }}
                                        </v-icon>

                                        <v-checkbox
                                            v-if="!item.isGroup"
                                            color="primary"
                                            hide-details
                                            class="p-0"
                                            :input-value="item == selectedTemplate"
                                            @click.native.capture="onItemSelect(item, $event)"
                                        >
                                        </v-checkbox>

                                    </v-list-item-action>

                                    <v-list-item-icon v-if="!item.isGroup">
                                        <v-icon
                                            :color="item.id == null ? '' : 'green darken-2'"
                                            small
                                        >
                                            fas fa-file-alt
                                        </v-icon>
                                    </v-list-item-icon>
                                    
                                    <v-list-item-content v-if="item.isGroup">
                                        <v-list-item-title>
                                            <span :class="['font-weight-bold', 'text-uppercase']">
                                                {{ $t(item.Value) }}
                                            </span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-content v-else>
                                        <v-list-item-title>
                                            <div class="d-flex">
                                                <div class="d-flex align-center flex-grow-1">
                                                    <div class="etw-text-container" v-tooltip.top-center='item.template_name ? item.template_name : ""'>
                                                        <span class="etw-text text-uppercase">{{item.template_name}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-list-item-title>
                                    </v-list-item-content>

                                </v-list-item>
                            </template>
                        </v-virtual-scroll>
                        <div v-else class="div-table-row">
                            <div class="cfl-placeholder">{{$t("К_сожалению,_по_Вашему_запросу_ничего_не_найдено")}}</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    v-if="selectedTemplate"
                    color="cyan"
                    text
                    depressed
                    @click="onOk"
                >
                    {{ $t("Применить") }} 
                </v-btn>

                <v-btn
                    color="blue-grey"
                    text
                    depressed
                    @click="onCancel"
                >
                    {{ $t("Отмена") }}
                </v-btn>

            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

import sys from '@/services/system';

export default {
    name: "TemplateSelectDlg",
    computed: {
        ...mapGetters(
        'global/dialogs/templateSelect',
        { 
            visible: 'isVisible',
            loading: 'isLoading',
            title: 'getTitle',
            data: 'getData',
            selectedTemplate: 'getSelectedTemplate'
        }),
        visibleItems() {
            this.searchRefreshKey;
            return this.$_.orderBy(this.data.filter(x => x.visible), ['sortIndex', 'score', (item) => { return item.isGroup ? item.Value : item.template_name }], ['asc', 'desc', 'asc']);
        },
        search: {
            get: function() {
                return this.$store.getters['global/dialogs/templateSelect/getSearch'];
            },
            set: _.debounce(function(v) {
                this.$store.commit('global/dialogs/templateSelect/SET_SEARCH', v);
            }, 500)
        },
    },
    data() {
        return {
            searchRefreshKey: 0
        }
    },
    methods: {
        ...mapActions('global/dialogs/templateSelect', ['ok', 'cancel']),
        async onOk() {
            await this.ok();
        },
        async onCancel() {
            await this.cancel();
        },
        onItemClick(item) {
            if (!item) return;

            if (!item.isGroup) {
                this.onItemSelect(item, null);
                return;
            }

            item.collapsed = !item.collapsed;

            for (let child of this.data.filter(x => x.parent == item.id)) {
                child.visible = item.collapsed ? false : (this.search == null || this.search.trim().length == 0) || sys.checkSearchWithScore(this.search, child, 'template_name');
            }
        },
        onItemSelect(item, event) {
            if (!item) return;

            let template = this.data.find(x => x.id == item.id && item.parent == x.parent);

            if (!template) return;

            this.$store.commit('global/dialogs/templateSelect/SET_SELECTED_TEMPLATE', template);
            
            if (event)
                event.stopPropagation();
        },
        applySearch(searchStr) {
            this.searchRefreshKey++;
            let isEmpty = searchStr == null || searchStr.trim().length == 0;

            if (isEmpty) {
                for (let item of this.data) {
                    item.score = 0;
                    item.visible = true;

                    if (item.isGroup)
                        item.collapsed = false;
                }
                
                return;
            }

            for (let item of this.data) {
                if (item.isGroup) {
                    item.collapsed = !this.isAnyChildVisible(item.id, searchStr);
                    item.visible = sys.checkSearchWithScore(searchStr, item, 'Value') || !item.collapsed;
                }
                else {
                    item.visible = sys.checkSearchWithScore(searchStr, item, 'template_name');
                }
            }
        },
        isAnyChildVisible(parentId, search) {
            return this.data.some(x => x.parent == parentId && sys.checkSearchWithScore(search, x, 'template_name'));
        },
        async refreshData() {
            this.$store.commit('global/dialogs/templateSelect/SET_LOADING', true);
            await this.$store.dispatch('global/dialogs/templateSelect/fetchData');
            this.applySearch(this.search);
            this.$store.commit('global/dialogs/templateSelect/SET_LOADING', false);
        }
    },
    watch: {
        search(v) {
            this.applySearch(v);
        }
    }
}
</script>